// @ts-strict-ignore
import React from 'react'
import ControllerRadioGroup from 'APP/Components/ControllerFields/ControllerRadioGroup'
import ControllerInput from 'APP/Components/ControllerFields/ControllerInput'
import I18n from 'APP/I18n'
import { Control } from 'react-hook-form'

const Pronouns = ({
  id,
  name,
  onFocus,
  isFocused,
  control,
  label,
  shouldShowPronounRadio,
  watchPronounRadio,
  noBottomMargin,
}: {
  id: string
  name: string
  onFocus: () => void
  isFocused: boolean
  control: Control<any, any>
  label: string
  shouldShowPronounRadio: boolean
  watchPronounRadio?: 'yes'
  noBottomMargin?: boolean
}) => {
  const showPronoun = watchPronounRadio === 'yes'
  const safePattern = /^[\p{L}\s\\/]*$/u

  return (
    <>
      {shouldShowPronounRadio && (
        <ControllerRadioGroup
          name="pronounsRadio"
          control={control}
          rules={{
            required: true,
            value: I18n.t('ProfileScreen.error.invalidPronouns'),
          }}
          label={`${I18n.t('ProfileScreen.pronounsRadio')}`}
          testID="PRONOUNS_RADIO_GROUP"
          options={[
            {
              label: I18n.t('ProfileScreen.yes'),
              value: 'yes',
            },
            {
              label: I18n.t('ProfileScreen.no'),
              value: 'no',
            },
          ]}
        />
      )}

      <ControllerInput
        id={id}
        name={name}
        control={control}
        autoCapitalize="none"
        rules={{
          required:
            shouldShowPronounRadio && showPronoun
              ? I18n.t('ProfileScreen.error.invalidPronouns')
              : false,
          pattern: {
            value: safePattern,
            message: I18n.t('ProfileScreen.error.invalidPronouns'),
          },
        }}
        label={label}
        infotip={`${I18n.t('ProfileScreen.hint.pronounsHint')}`}
        testID="UPDATE_PROFILE_SCREEN_PRONOUNS_FIELD"
        onFocus={onFocus}
        isFocused={isFocused}
        hide={shouldShowPronounRadio && !showPronoun}
        noBottomMargin={noBottomMargin}
      />
    </>
  )
}

export default Pronouns
